<template>

<core-modal :is-large="true" v-on:close="onClose" class="modal-wrapper">

	<template v-slot:head>

		Register your username

	</template>

	<template v-slot:default>

		<p>Registering is simple - just enter your BGG username and we will send you a GeekMail with a link to complete registration.</p>

        <core-form-input-textbox name="verifyname" v-on:validate="validate" placeholder="Enter BGG username" v-model="inputs.verifyname" :error="is.error" :disabled="is.success || is.loading" :validation="validation.verifyname" v-on:enter="onVerifyClick"></core-form-input-textbox>
        
        <div class="buttons">
            <core-button v-on:click.native="onVerifyClick" :loading="is.loading" :success="is.success" :disabled="!is.valid">{{ buttonText }}</core-button>
		</div>

        <h2>Why register?</h2>

		<p>You can already view your data, but by registering you get so much more;</p>

		<ul>
			<li>Weekly syncs</li>
			<li>Manage tags</li>
			<li>Create lists</li>
			<li>Customise settings</li>
			<li>Use filter presets</li>
			<li>Create and join groups</li>
			<li>Custom H-indexes</li>
			<li>Game renaming</li>
			<li>Deep syncs for private data</li>
			<li>View sync history</li>
			<li>View your GeekBuddies combined collection</li>
			<li>Become a patreon and get exclusive perks</li>
			<li>And much more!</li>
		</ul>

		<p>It takes just a few seconds!</p>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false,
				success: false,
				error: false
			},

			inputs: {
				verifyname: ''
			},

			validation: {
				verifyname: { exists: true }
			}

		}

	},

	computed: {

		buttonText: function() {

			return (this.is.success) ? 'GeekMail sent!' : 'Send GeekMail'

		}

	},

	methods: {

		onVerifyClick: function() {

			if (this.is.valid) {

				this.is.loading = true

				this.$store.dispatch('api/account/verify', {
					name: this.inputs.verifyname
				}).then(function() {

					this.is.error = false
					this.is.success = true
					this.is.loading = false

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.buttons {
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 20px;
}

.modal-wrapper >>> .textbox.bkg-light .textbox-input {
	border-color: #ddd;
}

</style>